export const METRIC_PERIOD: number = 14;

export const METRICS_GAP: number = 0.15;
